<template>
  <div class="select-label-wrapper">
    <label
      :class="classNames"
      :style="styleObject"
    >{{ label }}</label>
    <slot />
  </div>
</template>

<script>
import { createComponent } from '@vue/composition-api'

const LabelWrapper = createComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    bold: {
      type: Boolean,
      default: true,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    classNames() {
      return [
        'pb-1',
        {
          'font-weight-bold': this.bold,
        },
      ]
    },
    styleObject() {
      return {
        fontSize: '12px',
        ...this.styles,
      }
    },
  },
})

export default LabelWrapper
</script>

<style lang="scss" scoped>
.select-label-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
</style>
